// src/components/cards/TestimonialCard.js
import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';

/**
 * TestimonialCard displays a single customer testimonial.
 * It's designed to be animated by its parent container using Framer Motion variants.
 * @param {object} props - The component props.
 * @param {object} props.testimonial - The testimonial data.
 * @param {object} props.variants - The animation variants passed from the parent.
 * @return {React.ReactElement} The TestimonialCard component.
 */
const TestimonialCard = ({ testimonial, variants }) => {
  return (
    <motion.div
      variants={variants}
      className="bg-white rounded-2xl p-6 border border-gray-200 shadow-lg hover:shadow-xl transition-shadow"
    >
      <div className="flex items-center gap-1 mb-4">
        {[...Array(testimonial.rating)].map((_, i) => (
          <Star key={i} className="w-5 h-5 text-yellow-400 fill-current" />
        ))}
      </div>
      <p className="text-gray-600 mb-6 italic">{testimonial.text}</p>
      <div>
        <div className="font-semibold text-gray-800">{testimonial.name}</div>
        <div className="text-gray-500 text-sm">{testimonial.company}</div>
      </div>
    </motion.div>
  );
};

export default TestimonialCard;
